import { ERROR_PAGE_THEME_COLOR } from '@/feature/error/constants/colorCode';
import { useDeviceSize } from '@/hooks/useDeviceSize';
import { ThemeProviderWrap } from '@/providers/ThemeProvider';
import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import Stack, { type StackProps } from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import type { PropsWithChildren, ReactElement } from 'react';

type ErrorLayoutProps = {
  mainTitle: string;
  subTitle?: string;
  iconElement: ReactElement;
};

export const ErrorLayout: React.FC<PropsWithChildren<ErrorLayoutProps>> = ({
  children,
  mainTitle,
  subTitle,
  iconElement,
}) => {
  const { isPcSize } = useDeviceSize();

  const stackProps: StackProps = isPcSize
    ? {
        direction: 'row',
      }
    : {
        // NOTE: SP, Tablet
        direction: 'column',
        alignItems: 'center',
      };

  return (
    // TODO: 一旦エラーが出るので解消する
    <ThemeProviderWrap>
      {/* エラーの範囲を調整する */}
      <Dialog sx={{ p: 0 }} fullScreen open>
        <Stack
          {...stackProps}
          sx={{
            background: ERROR_PAGE_THEME_COLOR,
            color: '#fff',
            height: '100vh',
            width: '100vw',
          }}
          gap={2}
        >
          <Stack
            sx={{
              alignItems: 'center',
              justifyContent: 'center',
              width: '50%',
            }}
          >
            <Typography sx={{ fontSize: '5rem' }} variant='h1'>
              {mainTitle}
            </Typography>
            {subTitle !== undefined && (
              <Typography sx={{ fontSize: '3rem' }} variant='h2'>
                {subTitle}
              </Typography>
            )}
            <Box sx={{ mt: 2, width: '100%', textAlign: 'center' }}>
              {iconElement}
            </Box>
          </Stack>
          <Stack
            sx={{
              alignItems: 'center',
              justifyContent: 'center',
              width: '50%',
            }}
          >
            {children}
          </Stack>
        </Stack>
      </Dialog>
    </ThemeProviderWrap>
  );
};
